import { Link } from "react-router-dom";
import classnames from "utils/classnames";

const mapTypeToBg = {
  primary: 'bg-black text-black text-white',
  secondary: 'bg-transparent border-2 border-black hover:bg-black hover:text-white hover:text-black transition-colors duration-300 ease-in-out',
  link: 'text-blue-500 underline'
}

const mapSize = {
  medium: 'px-8 py-4 text-sm',
  big: 'px-10 py-8',
}

const Button = ({ 
  children, 
  className, 
  type = 'primary', 
  size = 'medium', 
  href, 
  to,
  ...rest 
}) => {
  // Generate classnames
  const rootClassnames = classnames('relative font-bold block w-fit', mapTypeToBg[type], mapSize[size], className );

  const props = {
    className: rootClassnames,
    // Check if to prop is passed, use that
    ...( to ? { to } : ( href ? { href } : {} )),
    ...rest
  }

  const Component = to ? Link : ( href ? 'a' : 'button' );

  return (
    <Component {...props}>
      { children }
    </Component>
  )
}

export default Button